export enum InteractionTypeEnum {
  BankingWindow = 1,
  ParameterDownload = 2
}
